import React from 'react';
import { Select as BaseUISelect } from 'baseui/select';
import _isFunction from 'lodash/isFunction';
import { hydrateSelectValue, dehydrateSelectValue, getSelectOptions } from './helper';

interface ISelectProps {
	value: any;
	multi?: boolean;
	options?: any;
	onChange: (...event: any[]) => void;
	labelKey?: string;
	valueKey?: string;
	onChangeCallback?: any;
}

const Select: React.FC<ISelectProps & React.ComponentProps<typeof BaseUISelect>> = (props) => {
	const { value, multi = false, options, onChange, onChangeCallback } = props;

	const handleOnChange = ({ value: changedValue }: { [key: string]: any }) => {
		onChange(dehydrateSelectValue(changedValue, options, multi));
		if (_isFunction(onChangeCallback)) {
			onChangeCallback(props);
		}
	};

	return (
		<BaseUISelect
			{...props}
			onChange={handleOnChange}
			value={options && options.length > 0 ? hydrateSelectValue(value, options, onChange, multi) : []}
			options={getSelectOptions(options, multi)}
		/>
	);
};

export default Select;
